import React from 'react';
import {connect} from 'react-redux';
import {AppDispatch, RootState} from "../../../../store/store";
import {Box, Typography} from "@mui/material";
import Text from '../../../app/text/text';
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import {localize} from "../../../../helpers/localization";
import * as meetingController from '../../../../controllers/meetings';
import {ROLES} from "../../../../constants/roles";
import {MeetingSummary} from "../../../../controllers/meetings";
import {withTheme} from "@mui/styles";
import {WithTheme} from "@mui/styles/withTheme/withTheme";
import {logException} from "../../../../controllers/system";
Chart.register(ArcElement, Tooltip, Legend);

type IProps = {
}

type IState = {
    data: number[]
}

const mapStateToProps = (state: RootState) => {
    return {
        lang: state.settings.lang,
        role: state.user.role,
        userId: state.user._id
    };
}

const mapDispatchToProps = (dispatch: AppDispatch) => {
    return {
    };
};

type ReduxType = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & IProps & WithTheme<unknown>;

class MeetingRealtime extends React.Component<ReduxType, IState> {
    public readonly state: IState = {
        data: [0, 0, 0]
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        logException({error, errorInfo});
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        let userId: string | undefined = undefined;

        if (this.props.role === ROLES.Professional) userId = this.props.userId;
        meetingController.getSummary(userId).then((results: MeetingSummary | null) => {
            if (results) {
                this.setState((state: IState) => {
                    return {
                        ...state,
                        data: [
                            results.coming,
                            results.missingFollowUp,
                            results.done
                        ]
                    }
                });
            }
        });
    }

    render() {
        return (
            <Box>
                <Box sx={{display: 'flex', flexDirection: 'column'}}>
                    <Typography variant={'h5'}><Text>Meetings</Text></Typography>
                </Box>
                <Box sx={{flexGrow: 1, color: 'white'}}>
                    <Doughnut data={{
                        labels: [
                            localize('Coming', this.props.lang),
                            localize('Missing follow-up', this.props.lang),
                            `${localize('Done', this.props.lang)} (24H)`
                        ],
                        datasets: [
                            {
                                label: localize('Meetings', this.props.lang),
                                data: this.state.data,
                                backgroundColor: [
                                    '#90caf9',
                                    '#ffa726',
                                    '#66bb6a',
                                ],
                                borderColor: [
                                    '#90caf9',
                                    '#ffa726',
                                    '#66bb6a',
                                ],
                                borderWidth: 1,
                            },
                        ],
                    }}
                    options={{
                        plugins: {
                            legend: {
                                labels: {
                                    color: (this.props.theme as any).palette.text.primary
                                }
                            }
                        }
                    }}
                    />
                </Box>
            </Box>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTheme(MeetingRealtime));
